'use strict';

namespace Core {

    export class ScDialog {

        // bound
        fullScreen: boolean;

        private element: JQuery;
        private parentModal: ScModal;

        private visible: boolean = false;
        private animatingIn: boolean = false;
        private animatingOut: boolean = false;

        constructor (
            private $scope: ng.IScope,
            private animationUtil: any,
        ) {
        }

        init (element: ng.IAugmentedJQuery, modal: ScModal): void {

            this.element = element;
            this.parentModal = modal;

            // watch open state
            this.$scope.$watch('d.parentModal.open', (val) => {
                if (!_.isUndefined(val)) {
                    val ? this.handleOpen() : this.handleClose();
                }
            });
        }

        private handleOpen(): void {
            if (this.visible) {
                return;
            }

            // animate the dialog IN
            this.animatingIn = true; // applies class with transition
            this.visible = true;
            this.animationUtil.waitForTransition(this.element).then((el) => {
                this.animatingIn = false;
            });
        }

        private handleClose(): void {
            if (!this.visible) {
                return;
            }

            // animate the dialog OUT
            this.animatingOut = true; // applies class with transition
            this.animationUtil.waitForTransition(this.element).then((el) => {
                this.animatingOut = false;
                this.visible = false;
            });
        }

        private getDialogClasses = () => {
            return {
                'sc-c-dialog--full-screen': this.fullScreen,
                'u-fade-enter-active': this.animatingIn,
                'u-fade-exit-active': this.animatingOut,
                'u-transparent': !this.visible
            };
        }

        public close(): void {
            this.parentModal.onClose();
        }
    }

    angular
        .module('core')
        .directive('scDialog', (): ng.IDirective => {

            return {
                scope: {},
                restrict: 'E',
                require: '^scModal',
                replace: true,
                transclude: true,
                controller: ScDialog,
                controllerAs: 'd',
                bindToController: {
                    fullScreen: '=',
                },
                template: `<div class="sc-c-dialog" ng-class="d.getDialogClasses()" />`,
                link: (
                    scope: ng.IScope,
                    el: ng.IAugmentedJQuery,
                    attr: ng.IAttributes,
                    modalCtrl: ScModal,
                    transcludeFn
                ) => {

                    // transclude manually so we can access dialog's scope from the tanscluded content
                    transcludeFn(scope, (contents) => {
                        angular.forEach(contents, (node) => {
                            el.append(node);
                        });
                    });

                    scope.d.init(el, modalCtrl);
                }
            };

        });
}
